module.exports = "./img/f2308575dc64d9f1458e7bdd571d0434.jpg";